/* eslint-disable */

import * as customerManagementService from "../../services/customer";
import * as settings from "../../services/settings";

import { Button, Col, Row, Spin, Table, notification } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import React, { useCallback, useEffect, useState } from "react";

import { ModalCreateRoute } from "./modal/modalRoute";
import { ModalDelete } from "../model/modal/delete";
import permissions from "../../../configs/permission";
import { useAccessToken } from "../../contexts/AccessTokenContext";
import { usePermission } from "../../hooks/usePermission";

const initPage = { limit: 10, page: 1, total: 1 };

export const CreateCustomerRoutes = ({ t, detailData, onRoutesMutated }) => {
  const { hasPermission, isSuperuser } = usePermission();
  const { accessToken } = useAccessToken();
  const [search, setSearch] = useState(initPage);
  const [customerData, setCustomerData] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [customerRoutesData, setCustomerRoutesData] = useState([]);
  const [editCustomerRoutesData, setEditCustomerRoutesData] = useState([]);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [prepareDeleteData, setPrepareDeleteData] = useState({});

  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, message, description) => {
    api[type]({
      message: message,
      description: description,
    });
  };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onDeleteCustomerRoutes = async (data) => {
    setLoading(true);
    try {
      const response = await customerManagementService.deleteCustomerRoutes(accessToken, data.id);
      openNotificationWithIcon(settings.NotificationType.SUCCESS, <>{"Success."}</>, <>{"Delete routes success"}</>);
      setPrepareDeleteData({});
      setIsOpenDelete(false);
      await fetchCustomerRoutes();
      onRoutesMutated?.();
      setLoading(false);
    } catch (err) {
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      console.error("[CreateCustomerRoutes] onDeleteCustomerRoutes: ", err);
    }
  };

  const fetchCustomerRoutes = useCallback(
    async (param) => {
      setLoading(true);
      const params = { ...param };
      let getCustomerId = detailData.id;
      try {
        const data = await customerManagementService.getCustomerRoutes(accessToken, getCustomerId, params);
        setCustomerRoutesData(data);
        setSearch({ ...param });
      } catch (err) {
        console.error("[CreateCustomerRoutes] fetchCustomerRoutes: ", err);
        const { message } = settings.getErrorMessage(err);
        openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
        openNotificationWithIcon(settings.NotificationType.ERROR, <>{"Error."}</>, <>{"Get customer error"}</>);
      }
      setLoading(false);
    },
    [accessToken, detailData?.id]
  );
  useEffect(() => {
    setLoading(true);
    if (accessToken) {
      fetchCustomerRoutes();
      setLoading(false);
    }
  }, [accessToken, fetchCustomerRoutes]);

  const columns = [
    {
      title: t("Customer_Table.No"),
      dataIndex: "id",
      key: "id",
    },
    {
      title: t("Customer_Table.Origin"),
      dataIndex: "origin",
      key: "origin",
      render: (_, record) => {
        const origin = record.app_warehouse_app_customerroute_origin_idToapp_warehouse.warehouse_code || "";
        return <p>{origin}</p>;
      },
    },
    {
      title: t("Customer_Table.Destination"),
      dataIndex: "destination",
      key: "destination",
      render: (_, record) => {
        const destination = record.app_warehouse_app_customerroute_destination_idToapp_warehouse.warehouse_code || "";
        return <p>{destination}</p>;
      },
    },
    {
      title: t("Customer_Table.Edit"),
      key: "edit",
      width: 100,
      align: "center",
      render: (_, record) => (
        <Button
          type="link"
          disabled={!hasPermission(permissions.CustomerRoute?.CHANGE)}
          onClick={() => {
            setIsEdit(true);
            setEditCustomerRoutesData(record);
            showModal();
          }}
        >
          <EditOutlined />
        </Button>
      ),
    },
    {
      title: t("Customer_Table.Is_Delete"),
      key: "delete",
      width: 100,
      align: "center",
      render: (_, record) => (
        <Button
          type="link"
          disabled={!hasPermission(permissions.CustomerRoute?.DELETE)}
          onClick={() => {
            setIsOpenDelete(true);
            setPrepareDeleteData(record);
          }}
        >
          <DeleteOutlined />
        </Button>
      ),
    },
  ];

  return (
    <>
      {contextHolder}
      <Spin spinning={loading}>
        <Row align="middle" justify="end">
          <Col span={24}>
            <Table
              columns={columns}
              dataSource={customerRoutesData}
              scroll={{ x: "1440px", y: "500px" }}
              rowKey={(record) => record.id}
              pagination={{
                defaultPageSize: search.limit,
                current: search.page,
                pageSize: search.limit,
                total: search.total,
                onChange: (page, limit) => {
                  fetchCustomerRoutes({ ...search, page, limit });
                },
                showSizeChanger: true,
              }}
              style={{ cursor: "pointer" }}
              // onRow={(data) => ({
              //   onClick: () => openModal(data),
              // })}
            />
          </Col>
          <Col span={24}>
            <div className="flex justify-end mt-2">
              {hasPermission(permissions.CustomerRoute?.ADD) && (
                <Button
                  type="primary"
                  onClick={() => {
                    showModal();
                    setIsEdit(false);
                  }}
                >
                  {t("Button_Customer.BTN_Add_Routes")}
                </Button>
              )}
            </div>
          </Col>
        </Row>
        <ModalCreateRoute
          isModalOpen={isModalOpen}
          handleOk={handleOk}
          handleCancel={handleCancel}
          customerRoutesData={customerRoutesData}
          editCustomerRoutesData={editCustomerRoutesData}
          fetchCustomerRoutes={fetchCustomerRoutes}
          setIsModalOpen={setIsModalOpen}
          detailData={detailData}
          isEdit={isEdit}
          t={t}
          loading={loading}
          setLoading={setLoading}
          onRoutesMutated={onRoutesMutated}
        />
        <ModalDelete
          isOpen={isOpenDelete}
          handleCloseModal={() => {
            setIsOpenDelete(false);
          }}
          onClick={() => {
            onDeleteCustomerRoutes(prepareDeleteData);
          }}
          dataDetail={prepareDeleteData}
          t={t}
        />
      </Spin>
    </>
  );
};
